<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="page-header">
            <span class="bold">Feedback Tapping Report</span>
        </div>
    </div>
    <!-- opd feedback tapping report table -->
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                    <mat-panel-description>
                        <span class="bold">OPD Feedback Tapping Report</span>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')"
                            #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="getOpdTappingReportList()"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="OpdresetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                    <thead>
                        <tr class="text-center">
                            <th colspan="10">OPD Tapping Report of
                                <span *ngIf="opd_start_date"><b>{{opd_start_date | date}}</b> to <b>{{opd_end_date |
                                        date}}</b></span>
                                <span *ngIf="!opd_start_date"><b>{{todayDate | date }}</b></span>
                            </th>
                        </tr>
                        <tr class="text-center">
                            <th>BD NAME</th>
                            <th>OPD FEEDBACK TAPPING</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" *ngFor="let tappingReportData of opdReportList">
                            <td>{{tappingReportData.name}}</td>
                            <td>{{tappingReportData.total_opd_feedback_tapping ?
                                tappingReportData.total_opd_feedback_tapping : 0}}</td>
                        </tr>
                        <tr *ngIf="opd_report_loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !opdReportList.length">
                            <td colspan="5" class="text-center"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- ipd feedback tapping report table -->
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                    <mat-panel-description>
                        <span class="bold">IPD Feedback Tapping Report</span>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-3 mt-2">
                        <mat-select placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')"
                            #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="getIpdTappingReportList()"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="IpdresetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                    <thead>
                        <tr class="text-center">
                            <th colspan="10">IPD Tapping Report of
                                <span *ngIf="ipd_start_date"><b>{{ipd_start_date | date}}</b> to <b>{{ipd_end_date |
                                        date}}</b></span>
                                <span *ngIf="!ipd_start_date"><b>{{todayDate | date }}</b></span>
                            </th>
                        </tr>
                        <tr class="text-center">
                            <th>BD NAME</th>
                            <th>IPD FEEDBACK TAPPING</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" *ngFor="let IpdReportData of ipdReportList">
                            <td>{{IpdReportData.name}}</td>
                            <td>{{IpdReportData.total_ipd_feedback_tapping ? IpdReportData.total_ipd_feedback_tapping :
                                0}}</td>
                        </tr>
                        <tr *ngIf="ipd_report_loading">
                            <td colspan="2" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !ipdReportList.length">
                            <td colspan="2" class="text-center"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>